import type { SortState } from "../components/kii";
import type { WorkspaceActivity } from "../services/naraDoor";

/** Period choices; `undefined` days = all time. */
export const PERIODS = [
  { key: "days30", days: 30 },
  { key: "days90", days: 90 },
  { key: "all", days: undefined },
] as const;

const time = (iso: string | null) => (iso ? Date.parse(iso) : 0);

/** Epoch ms of the newest transcription, AI document or export; 0 when none. */
export const lastActivityAt = (w: WorkspaceActivity): number =>
  Math.max(time(w.lastTranscriptionAt), time(w.lastAiDocumentAt), time(w.lastExportAt));

const SORT_VALUES: Record<string, (w: WorkspaceActivity) => string | number> = {
  workspace: (w) => (w.name ?? w.workspaceId).toLowerCase(),
  lastActivity: lastActivityAt,
  recordings: (w) => w.recordings,
  transcriptions: (w) => w.transcriptions,
  aiDocuments: (w) => w.aiDocuments,
  exports: (w) => w.exports,
  lastLogin: (w) => time(w.lastLoginAt),
  boostsSpent: (w) => w.boostsSpent,
  boostsPurchased: (w) => w.boostsPurchased,
  boostsGranted: (w) => w.boostsGranted,
  boostsBalance: (w) => w.boostsBalance,
};

export function sortActivity(rows: WorkspaceActivity[], { column, direction }: SortState): WorkspaceActivity[] {
  const value = column && direction ? SORT_VALUES[column] : undefined;
  if (!value) return rows;
  const dir = direction === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => (value(a) < value(b) ? -dir : value(a) > value(b) ? dir : 0));
}

export const SORT_COLUMNS = Object.keys(SORT_VALUES);
